import React, { Component } from 'react';
import RoleService from '../../Services/roleService';
import urlHelper from '../../Helpers/urlHelper';

class DataTableActionButton extends Component {
  static defaultProps = {
    className: 'icon',
    innerClassName: '',
    iconName: 'fa-solid fa-circle',
    onClick: null,
    tooltipText: '',
    disabled: false,
    roleKey: '',
    text: '',
    url: '',
    isMarkedRed: false,
  };

  static openInNewTab = (url) => {
    if (!url.startsWith(urlHelper.getProperUrl())) {
      alert('Only internal links can be opened in a new tab from this component.');
      return;
    }

    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  };

  render() {
    const enabled =
      !this.props.disabled &&
      (!this.props.roleKey ||
        (this.props.roleKey && RoleService.CheckUserPermission('faicon', this.props.roleKey, 'visit')));

    return this.props.url ? (
      <a
        href={urlHelper.isUrlOnWhiteList(this.props.url) ? this.props.url : '/'}
        style={{ pointerEvents: enabled ? 'auto' : 'none' }}
        className='actionmenulink dataTableButtonLink'
        target='_blank'
        rel='noopener noreferrer'
      >
        <span
          className={`dataTabledropdownmenu ${enabled ? '' : 'dataTabledropdownmenuDisabled'}`}
          onClick={enabled ? this.props.onClick : null}
          disabled={!enabled}
        >
          <div
            className={`dataTableDropdownMenubuttonStyle ${enabled ? '' : 'dataTableDropdownMenubuttonStyleDisabled'}`}
          >
            <i className={this.props.iconName} />
          </div>
          <div
            className={`dataTableDropdownMenubuttonStyle ${enabled ? '' : 'dataTableDropdownMenubuttonStyleDisabled'}`}
          >
            {this.props.text}
          </div>
        </span>
      </a>
    ) : (
      <span
        className={`${this.props.isMarkedRed && 'redBackground '} dataTabledropdownmenu ${
          enabled ? '' : 'dataTabledropdownmenuDisabled'
        }`}
        onClick={enabled ? this.props.onClick : null}
        disabled={!enabled}
      >
        <div
          className={`dataTableDropdownMenubuttonStyle ${enabled ? '' : 'dataTableDropdownMenubuttonStyleDisabled'}`}
        >
          <i className={this.props.iconName} />
        </div>
        <div
          className={`dataTableDropdownMenubuttonStyle ${enabled ? '' : 'dataTableDropdownMenubuttonStyleDisabled'}`}
        >
          {this.props.text}
        </div>
      </span>
    );
  }
}

export default DataTableActionButton;
